!function () {
    var geq = window.geq = window.geq || [];
    if (geq.initialize) {
        return;
    }
    if (geq.invoked) {
        if (window.console && console.error) {
            console.error('GE snippet included twice.');
        }
        return;
    }
    geq.invoked = true;
    geq.methods = ['page', 'suppress', 'trackOrder', 'identify', 'addToCart', 'callBack', 'event'];
    geq.factory = function (method) {
        return function () {
            var args = Array.prototype.slice.call(arguments);
            args.unshift(method);
            geq.push(args);
            return geq;
        };
    };
    for (var i = 0; i < geq.methods.length; i++) {
        var key  = geq.methods[i];
        geq[key] = geq.factory(key);
    }
    geq.load            = function (key) {
        var script   = document.createElement('script');
        script.type  = 'text/javascript';
        script.async = true;
        if (location.href.includes('vge=true')) {
            script.src = 'https://s3-us-west-2.amazonaws.com/jsstore/a/' + key + '/ge.js?v=' + Math.random();
        } else {
            script.src = 'https://s3-us-west-2.amazonaws.com/jsstore/a/' + key + '/ge.js';
        }
        var first = document.getElementsByTagName('script')[0];
        first.parentNode.insertBefore(script, first);
    };
    geq.SNIPPET_VERSION = '1.6.1';
    geq.load('350H27Z');
}();

geq.page();

var _learnq = _learnq || [];

function addedToCart() {
    fetch(window.location.origin + '/cart.js')
        .then(res => res.clone().json().then(data => {            
            var cart = {
                total_price         : data.total_price / 100,
                $value              : data.total_price / 100,
                total_discount      : data.total_discount,
                original_total_price: data.original_total_price / 100,
                items               : data.items
            };
            if (item !== 'undefined') {
                cart = Object.assign(cart, item);
            }
            _learnq.push(['track', 'Added to Cart', cart]);
            geq.addToCart(item);
        }));
}

function checkCartUpdate() {
    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/cart.js', true);

    xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
            var cart = JSON.parse(xhr.responseText);

            if (cart.item_count > 0) {
                addedToCart();
            }
        }
    };

    xhr.send();
}

document.querySelector('button[name="add"]').addEventListener('click', function (event) {
    checkCartUpdate();
});
